import { render, staticRenderFns } from "./quesSuccess92.vue?vue&type=template&id=1effff5a"
import script from "./quesSuccess92.vue?vue&type=script&lang=js"
export * from "./quesSuccess92.vue?vue&type=script&lang=js"
import style0 from "./quesSuccess92.vue?vue&type=style&index=0&id=1effff5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports